module.exports = __webpack_public_path__ + "img/logo-header.91958982.png";